import React, { useEffect, useRef, useState } from "react";
import styles from "../../pages/styles";

const skills = [
  "Game Design",
  "Coding",
  "3D Art",
  "Video Editing",
  "Website Development",
  "Roblox Coding",
  "App Development",
  "Minecraft Modding",
  "and so many more!",
];

const WistiaVideo = () => {
  useEffect(() => {
    // Load the Wistia player script
    const script1 = document.createElement("script");
    script1.src = "https://fast.wistia.com/player.js";
    script1.async = true;
    document.body.appendChild(script1);

    // Load the embed script for video with media-id "2ix7yjhmlt"
    const script2 = document.createElement("script");
    script2.src = "https://fast.wistia.com/embed/2ix7yjhmlt.js";
    script2.async = true;
    script2.type = "module";
    document.body.appendChild(script2);

    // Clean up scripts on component unmount
    return () => {
      document.body.removeChild(script1);
      document.body.removeChild(script2);
    };
  }, []);

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        paddingTop: "56.25%", // 16:9 aspect ratio
      }}
    >
      <wistia-player
        media-id="2ix7yjhmlt"
        aspect="1.7777777777777777"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
        }}
      ></wistia-player>
    </div>
  );
};

const FreeTrialSkills = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);
  const hasAnimatedRef = useRef(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !hasAnimatedRef.current) {
            setIsVisible(true);
            hasAnimatedRef.current = true;
            observer.unobserve(entry.target);
          }
        });
      },
      { 
        threshold: 0.15,
        rootMargin: '0px 0px -50px 0px'
      }
    );

    const currentRef = sectionRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  return (
    <div className="mx-auto py-8 md:py-10" ref={sectionRef}>
      <div className="flex flex-col md:flex-row gap-6 items-center justify-between w-full px-1 md:px-20">
        {/* Text and Skills Section */}
        <div className="flex flex-col items-center md:items-start md:w-1/2">
          <h2 className={`${styles.biggerheadingdark} mb-3 md:mb-4 text-center md:text-left`}>
            What Your Child Will Learn
          </h2>
          <p className={`${styles.paragraph} mb-3 md:mb-4 text-center md:text-left`}>
          We're here to guide your child on a learning adventure with expertise, offering lessons across all technology topics.
          </p>
          <div className="flex flex-wrap gap-4 justify-center md:justify-start">
            {skills.map((skill, index) => (
              <Bubble key={index} text={skill} index={index} isVisible={isVisible} />
            ))}
          </div>
        </div>
        {/* Wistia Video Section */}
        <div className="flex-shrink-0 w-full md:w-1/2 max-w-[640px]">
          <WistiaVideo />
        </div>
      </div>
    </div>
  );
};

const Bubble = ({ text, index, isVisible }) => {
  // Use index-based values for consistent animations
  const floatDuration = 4 + (index % 3) * 1.5;
  const translateY = 3 + (index % 4) * 5;
  
  const style = {
    "--animation-duration-y": `${floatDuration}s`,
    "--translate-y": `${translateY}px`,
    "--fade-delay": `${index * 0.1}s`,
  };

  return (
    <div
      className={`bubble bubble-entrance bg-orangeprimary/90 hover:bg-orangeprimary rounded-full py-2.5 px-5 text-center shadow-sm hover:shadow-md transition-all border-2 border-orangeprimary ${
        isVisible ? 'bubble-visible' : ''
      }`}
      style={style}
    >
      <p className={`${styles.paragraph} text-md mb-0 font-medium`}>{text}</p>
    </div>
  );
};

export default FreeTrialSkills;
